<div class="container-sm">
  <div class="container-sm-custom">
    <br>
    <div class="modal-content box-shadow box-shadow1">
      <div class="modal-header">
        <h1 class="title text-success"><i class="fa fa-user-circle"
                                          aria-hidden="true"></i> {{ "TITLE.SIGN-UP" | translate }}</h1>
      </div>
      <div class="modal-body">
        <form autocomplete="off" [formGroup]="personForm">
          <div class="row">
            <div class="col-md-6">
              <label for="documentType" class="col-form-label mb-6">{{ "LABEL.DOCUMENT-TYPE" | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class="fa fa-id-card" aria-hidden="true"></i></div>
                </div>
                <select id="documentType"
                        class="form-control uppercase custom-input"
                        formControlName="documentType"
                        [(ngModel)]="person.documentType"
                        (ngModelChange)="onChangeDocType()"
                        [class.is-invalid]="isInvalidControl('documentType')">
                  <option *ngFor="let identifyDocument of identificationDocuments"
                          [ngValue]="identifyDocument.id">
                    {{'SELECT.OPTIONS.' + identifyDocument.shortDescription | translate}}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <label for="documentNumber" class="col-form-label mb-6">{{ "LABEL.DOCUMENT-NUMBER" | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">N°</div>
                </div>
                <input type="text"
                       class="form-control custom-input"
                       id="documentNumber"
                       formControlName="documentNumber"
                       [(ngModel)]="person.documentNumber"
                       (keyup)="cleanDataAfterChanges()"
                       [class.is-invalid]="isInvalidControl('documentNumber')">
                <div class="input-group-append">
                  <button class="btn btn-outline-success" (click)="search()"><i class="fa fa-search"></i></button>
                </div>
              </div>
              <small *ngIf="isInvalidControl('documentNumber')"
                     class="text-danger">
                {{getErrorMessageBy('documentNumber') | translate}}
              </small>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label for="firstName" class="col-form-label mb-6">{{ "LABEL.NAMES" | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class="fa fa-user" aria-hidden="true"></i></div>
                </div>
                <input type="text"
                       class="form-control uppercase custom-input"
                       id="firstName"
                       formControlName="firstname"
                       [(ngModel)]="person.firstname"
                       [class.is-invalid]="isInvalidControl('firstname')">
              </div>
              <small *ngIf="isInvalidControl('firstname')"
                     class="text-danger">
                {{getErrorMessageBy('firstname')}}
              </small>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label for="lastName" class="col-form-label mb-6">{{ "LABEL.FATHERS-LAST-NAME" | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class="fa fa-user" aria-hidden="true"></i></div>
                </div>
                <input type="text"
                       class="form-control uppercase custom-input"
                       id="lastName"
                       formControlName="lastname"
                       [(ngModel)]="person.lastname"
                       [class.is-invalid]="isInvalidControl('lastname')">
              </div>
              <small *ngIf="isInvalidControl('lastname')"
                     class="text-danger">
                {{getErrorMessageBy('lastname')}}
              </small>
            </div>
            <div class="col">
              <label for="lastName2" class="col-form-label">{{ "LABEL.MOTHERS-LAST-NAME" | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class="fa fa-user"></i></div>
                </div>
                <input type="text"
                       class="form-control uppercase custom-input"
                       id="lastName2"
                       formControlName="lastname2"
                       [(ngModel)]="person.lastname2"
                       [class.is-invalid]="isInvalidControl('lastname2')">
              </div>
              <small *ngIf="isInvalidControl('lastname2')"
                     class="text-danger">
                {{getErrorMessageBy('lastname2')}}
              </small>
            </div>
          </div>
          <div class="form-row">
            <div class="col">
              <label for="job" class="col-form-label mb-6">{{ "LABEL.JOB" | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class="fa fa-briefcase" aria-hidden="true"></i></div>
                </div>
                <select class="form-control uppercase custom-input"
                        id="job"
                        formControlName="job"
                        [(ngModel)]="person.jobId"
                        [class.is-invalid]="isInvalidControl('job')">
                  <option *ngFor="let job of jobs" [value]="job.id"> {{job.description | translate}} </option>
                </select>
              </div>
              <small *ngIf="isInvalidControl('job')"
                     class="text-danger">
                {{ "MESSAGE.JOB-IS-REQUIRED" | translate }}
              </small>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <label for="email" class="col-form-label mb-6">{{ "LABEL.E-MAIL" | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class="fa fa-envelope" aria-hidden="true"></i></div>
                </div>
                <input type="email"
                       class="form-control custom-input"
                       id="email"
                       formControlName="email"
                       [(ngModel)]="person.email"
                       [class.is-invalid]="isInvalidControl('email')">
              </div>
              <small *ngIf="isInvalidControl('email')"
                     class="text-danger">
                {{getErrorMessageBy('email')}}
              </small>
            </div>
            <div class="col-md-4">
              <label for="phone" class="col-form-label mb-6">{{ "LABEL.TELEPHONE" | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class="fa fa-phone" aria-hidden="true"></i></div>
                </div>
                <input type="text"
                       class="form-control custom-input"
                       id="phone"
                       formControlName="phoneNumber"
                       [(ngModel)]="person.cellphone"
                       [class.is-invalid]="isInvalidControl('phoneNumber')">
                <small *ngIf="isInvalidControl('phoneNumber')"
                       class="text-danger">
                  {{getErrorMessageBy('phoneNumber')}}
                </small>
              </div>
            </div>
          </div>
          <!--        <div class="row">-->
          <br>
          <div class="row">
            <div class="col-md-8">
              <label for="customRubricFile" class="col-form-label  mb-6">{{ "LABEL.RUBRIC" | translate }}</label>
              <div class="custom-file content-file">
                <input type="file"
                       class="custom-file-input"
                       accept="image/jpeg, image/png"
                       alife-file-to-base64
                       id="customRubricFile"
                       (change)="readSelectedRubric($event)"
                       (onFileChanged)="changeStatus2($event)"
                       [class.is-invalid]="isInvalidControl('rubricFilename2Show')">
                <small *ngIf="isInvalidControl('rubricFilename2Show')"
                       class="text-danger">
                  {{ "MESSAGE.SELECT-RUBRIC" | translate }}
                </small>
                <div class="custom-file-label">
                  <label for="customRubricFile">
                    {{personForm.get('rubricFilename2Show').value ? personForm.get('rubricFilename2Show').value : ('MESSAGE.SELECT' | translate)}}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <label for="job" class="col-form-label  mb-6">{{ "LABEL.PREVIEW" | translate }}</label>
              <div>
                <img [src]="defaultRubricSrc" #rubricPic style="{{styleDimensionsRubric}}" alt="Rubric">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8">
              <label for="obverseDNI"
                     class="col-form-label mb-6">{{ "LABEL.IMAGE-FRONT-OF-THE-IDENTITY-DOCUMENT" | translate }}</label>
              <div class="custom-file content-file">
                <input type="file"
                       class="custom-file-input"
                       accept="image/jpeg, image/png"
                       alife-file-to-base64
                       id="obverseDNI"
                       (change)="readSelectedDocumentFront($event)"
                       (onFileChanged)="changeStatus3($event)"
                       [class.is-invalid]="isInvalidControl('documentFrontFilename2Show')">
                <small *ngIf="isInvalidControl('documentFrontFilename2Show')"
                       class="text-danger">
                  {{ "MESSAGE.SELECT-IMAGE-OF-FRONT-OF-IDENTITY-DOCUMENT" | translate }}
                </small>
                <div class="custom-file-label">
                  <label for="obverseDNI">
                    {{personForm.get('documentFrontFilename2Show').value ? personForm.get('documentFrontFilename2Show').value : ('MESSAGE.SELECT' | translate)}}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <label for="obverseDNI" class="col-form-label  mb-6">{{ "LABEL.PREVIEW" | translate }}</label>
              <div>
                <img [src]="defaultDocumentFrontSrc" #rubricPic style="{{styleDimensionsRubric}}" alt="Rubric">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8">
              <label for="backDNI"
                     class="col-form-label  mb-6">{{ "LABEL.IMAGE-BACK-OF-THE-IDENTITY-DOCUMENT" | translate }}</label>
              <div class="custom-file content-file">
                <input type="file"
                       class="custom-file-input"
                       accept="image/jpeg, image/png"
                       alife-file-to-base64
                       id="backDNI"
                       (change)="readSelectedBackDNI($event)"
                       (onFileChanged)="changeStatus4($event)"
                       [class.is-invalid]="isInvalidControl('documentRearFilename2Show')">
                <small *ngIf="isInvalidControl('documentRearFilename2Show')"
                       class="text-danger">
                  {{ "MESSAGE.SELECT-IMAGE-OF-BACK-OF-IDENTITY-DOCUMENT" | translate }}
                </small>
                <div class="custom-file-label">
                  <label for="backDNI">
                    {{personForm.get('documentRearFilename2Show').value ? personForm.get('documentRearFilename2Show').value : ('MESSAGE.SELECT' | translate)}}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <label for="backDNI" class="col-form-label  mb-6">{{ "LABEL.PREVIEW" | translate }}</label>
              <div>
                <img [src]="defaultDocumentRearSrc" #rubricPic style="{{styleDimensionsRubric}}" alt="Rubric">
              </div>
            </div>
          </div>
          <!--        </div>-->
          <div class="row">
            <div class="col">
              <label for="country" class="col-form-label  mb-6">{{ "LABEL.COUNTRY" | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class="fa fa-globe" aria-hidden="true"></i></div>
                </div>
                <select class="form-control custom-input"
                        id="country"
                        formControlName="country"
                        [(ngModel)]="person.countryId"
                        [class.is-invalid]="isInvalidControl('country')">
                  <option *ngFor="let country of countries" [value]="country.id"> {{country.name | translate}} </option>
                </select>
              </div>
              <small *ngIf="isInvalidControl('country')"
                     class="text-danger">
                {{ "MESSAGE.NATIONALITY-IS-REQUIRED" | translate }}
              </small>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <div class="container">
          <div class="row justify-content-end">
            <div class="btn-padding-dlg">
              <button type="button" class="btn btn-success w-100 btn-lg"
                      (click)="verificationCode()">
                <i class="fa fa-bookmark"></i> {{ "BUTTON.REGISTER" | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br>
  <app-loading *ngIf="loading"></app-loading>
</div>
